export function parseUrl(url: string): URL {
  const parser = document.createElement('a');
  parser.href = url;
  return new URL(parser.href);
}

export function serializeUrl(url: URL): string {
  return url.toString();
}

export function toPath(url: string): string {
  const parsedUrl = parseUrl(url);
  return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
}
